export default "__VITE_ASSET__DhUMf5Ml__"